const stylesTemplates = {
  username: {
    tag: 'div',
    styles: 'color:#9E150B;font-size:15px;line-height:18px;font-weight: bold;text-transform: capitalize'
  },
  position: {
    tag: 'div',
    styles: 'color:#AFAFAF;font-size:12px;line-height:14px;padding: 5px 0 0 0'
  },
  phone: {
    tag: 'span',
    styles: 'color:#838383;font-size:13px;line-height:16px;padding:0 18px 0 7px;'
  },
  companyPhone: {
    tag: 'span',
    styles: 'color:#838383;font-size:13px;line-height:16px;padding:0 18px 0 7px;'
  },
  companyAddress: {
    tag: 'span',
    styles: 'color:#838383;font-size:13px;line-height:16px;padding:0 18px 0 7px;'
  },
  socialsIcons: {
    tag: 'div',
    styles: 'padding: 5px 0 0 0;'
  },
  information: {
    tag: 'p',
    styles: 'padding: 20px 0 0 0;color:#AFAFAF;font-size:10px;line-height: 129.34%;'
  },
  awards: {
    tag: 'div',
    styles: 'padding: 6px 0 0 0;'
  },
  block: {
    tag: 'div',
    styles: 'margin: 5px 0 0 0;'
  },
  additional: {
    tag: 'div',
    styles: 'margin: 5px 0 0 0;'
  },
  emailStyle: 'color:#838383;font-size:13px;line-height:16px;padding:0 18px 0 7px;text-decoration:none;',
  companySiteStyle: 'color:#838383;font-size:13px;line-height:16px;padding:0 18px 0 7px;text-decoration:none'
}

export default stylesTemplates



// WEBPACK FOOTER //
// ./src/constants/signatureGmail/stylesTemplates.js